import { Component, OnDestroy, OnInit, ViewEncapsulation, Input, Inject, Optional } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { FuseConfigService } from './../../../../@fuse/services/config.service';
import { navigation } from './../../../navigation/navigation';
import { UserInfoService, ShellDomainProvider } from '@ecap3/core';

@Component({
    selector: 'vertical-layout-1',
    templateUrl: './layout-1.component.html',
    styleUrls: ['./layout-1.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class VerticalLayout1Component implements OnInit, OnDestroy {
    fuseConfig: any;
    navigation: any;
    hasDynamicToolbar: boolean = false;
    hasDynamicQuickPanel: boolean = false;
    hasDynamicNavBarConfig: boolean = false;
    hasDynamicFooter: boolean = false;
    showChatPanel: boolean;
    @Input() bannerComponent : any;
    @Input() toolbarComponent: any;
    @Input() quickPanelComponent: any;
    @Input() userInfo: any;
    @Input() footerComponent: any;
    @Input() chatPanelComponent: any;
    @Input() sidePanelComponent: any;
    public isZoomControl: boolean = false;
    // Private
    private _unsubscribeAll: Subject<void>;

    /**
     * Constructor
     *
     * param {FuseConfigService} _fuseConfigService
     */
    constructor(private _fuseConfigService: FuseConfigService,
        private userInfoService: UserInfoService,
        @Optional() @Inject('ISecurityService') private ISecurityService) {
        // Set the defaults
        this.navigation = navigation;

        // Set the private defaults
        this._unsubscribeAll = new Subject();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * On init
     */
    ngOnInit(): void {
        // Subscribe to config changes
        this._fuseConfigService.config
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe((config) => {
                this.fuseConfig = config;
                // floating chat panel show/hide configuration added
                if (ShellDomainProvider['api']['isFloatingChatPanelEnable']) {
                    this.userInfoService.currentUser.subscribe((result: any) => {
                        if (result !== 'DEFAULT_MESSAGE' && result !== 'LOGOUT_MESSAGE') {
                            //console.log(this.fuseConfig);
                            const userROle = this.ISecurityService ? this.ISecurityService.getUserRole() : null;
                            if (result.UserId && userROle) {
                                if (this.fuseConfig && this.fuseConfig.layout && this.fuseConfig.layout.floatingChatPanelConfig && this.fuseConfig.layout.floatingChatPanelConfig[userROle] && this.fuseConfig.layout.floatingChatPanelConfig[userROle]['showChatPanel']) {
                                    this.showChatPanel = true;
                                }
                            } else {
                                this.showChatPanel = false;
                                console.log('sorry no user role configuration provided for chat panel');
                            }
                        } else {
                            this.showChatPanel = false;
                        }
                        this.isZoomControl = this.fuseConfig.layout.zoomControl
                    });
                }
            });
        this.hasDynamicToolbar = this.toolbarComponent ? true : false;
        this.hasDynamicQuickPanel = this.quickPanelComponent ? true : false;
        this.hasDynamicFooter = this.footerComponent ? true : false;
    }
    /**
     * On destroy
     */
    ngOnDestroy(): void {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next(null as any);
        this._unsubscribeAll.complete();
    }
}
